import React from 'react';
import { SectionHeading } from './SectionHeading';
import { COMPARISON_ROWS } from '../data/content';
export function ComparisonSection() {
  return <section className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingTop: "18px",
    paddingBottom: "0px"
  }} data-id="element-46" data-mp="3e7kfa4y0b8oa">
      <div className="mx-auto max-w-content px-5" data-id="element-47" data-mp="34fxtxfryft7t">
        <SectionHeading eyebrow="⚖️ THE REAL COST" title="How much does it cost" highlight="not to have it?" data-id="element-48" data-mp="34f4vd235ga0r" />

        <p className="mt-4 text-center text-xs font-semibold uppercase tracking-wide text-white/35 md:hidden" data-id="element-49" data-mp="2zegvrs0uukux">
          ← Scroll to see full table →
        </p>

        <div className="hide-scrollbar mt-3 overflow-x-auto rounded-2xl border border-ink-700" data-id="element-50" data-mp="2qgy5a84fzebn">
          <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-51" data-mp="2lhtzlrgq7yq2">
            <caption className="sr-only" data-id="element-52" data-mp="op1wh69nsikk">Life with and without Pain Reset</caption>
            <thead data-id="element-53" data-mp="jpfigum0ayap">
              <tr className="bg-ink-800" data-id="element-54" data-mp="joxh5jkhltvx">
                <th className="px-5 py-2.5 text-xs font-extrabold uppercase tracking-[0.15em] text-white/60" data-id="element-55" data-mp="jq8hf9eq4jia">
                  Situation
                </th>
                <th className="px-5 py-2.5 text-xs font-extrabold uppercase tracking-[0.15em] text-white/40" data-id="element-56" data-mp="3egybsgotohfh">
                  Without Pain Reset
                </th>
                <th className="px-5 py-2.5 text-xs font-extrabold uppercase tracking-[0.15em] text-lime-400" data-id="element-57" data-mp="35g051qn01vt7">
                  With Pain Reset
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-ink-700 bg-ink-850" data-id="element-58" data-mp="1zb7gu5e9wfo">
              {COMPARISON_ROWS.map(row => <tr key={row.situation} data-id="element-59" data-mp="3jfsrvavenrvw">
                  <th scope="row" className="px-5 py-2.5 text-sm font-bold text-white/85" data-id="element-60" data-mp="3jerh77iax7ep">
                    {row.situation}
                  </th>
                  <td className="px-5 py-2.5 text-sm text-white/45" data-id="element-61" data-mp="3ocj8bzb4gphu">{row.without}</td>
                  <td className="px-5 py-2.5 text-sm font-semibold text-lime-400" data-id="element-62" data-mp="fwzht81u5l6h">{row.with}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-6 text-center text-xl font-extrabold text-white sm:text-2xl" data-id="element-63" data-mp="ukpzrzffnn4m">
          “Stop massaging the echo. <span className="text-lime-400" data-id="element-64" data-mp="pn7q26tld3vk">Fix the source.</span>” 🌿
        </p>
      </div>
    </section>;
}